import React, { useEffect } from 'react';

const Sidebar = ({ currentStep, completedSteps, toolId, isMobileMenuOpen, setIsMobileMenuOpen }) => {

  const getSubtitleByRoute = (toolId) => {
    if (toolId === '1' || toolId === 'ncodes') {
      return 'Find Your N Codes';
    } else if (toolId === '2' || toolId === 'ncodes-2') {
      return 'Find Your N Codes About Others';
    } else if (toolId === '3' || toolId === 'ncodes-3') {
      return 'Find Your Sales N Codes Assessment';
    } else {
      return 'Find Your N Codes';
    }
  };

  const steps = [
    { number: 1, title: 'Step 1', subtitle: 'Select minimum 24 N Codes.' },
    { number: 2, title: 'Step 2', subtitle: 'Select 12 N Codes.' },
    { number: 3, title: 'Step 3', subtitle: 'Select  6 N Codes.' },
    { number: 4, title: 'Step 4', subtitle: 'Showing Selected 6 N Codes' },
    { number: 5, title: 'Step 5', subtitle: 'The E Codes Against Your 6 N Codes Are:' }
  ];

  // Close mobile menu when screen resizes to desktop
  useEffect(() => {
    const handleResize = () => {
      if (window.innerWidth >= 993) {
        setIsMobileMenuOpen(false);
        document.body.classList.remove('mobile-menu-open');
      }
    };

    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, [setIsMobileMenuOpen]);

  // Handle body scroll lock
  useEffect(() => {
    if (isMobileMenuOpen) {
      document.body.classList.add('mobile-menu-open');
    } else {
      document.body.classList.remove('mobile-menu-open');
    }
  }, [isMobileMenuOpen]);

  const closeMobileMenu = () => {
    setIsMobileMenuOpen(false);
  };

  const SidebarContent = () => (
    <div className="px-6 py-10">
      <div className="flex items-center mb-8 justify-center">
        <img src="./../assets/images/Logo-Incredible-Leaders.png" alt="N Codes" />
      </div>

      <div className="space-y-6">
        {steps.map((step, index) => {
          const isCompleted = completedSteps.includes(step.number);
          const isCurrent = currentStep === step.number;

          return (
            <div key={step.number} className="flex items-start">
              <div className="flex flex-col items-center mr-4">
                {/* square rounded badge to match design */}
                <div className={`p-[11px_12px] w-[34px] h-[34px] flex justify-center items-center font-lato not-italic font-semibold text-[16px] leading-[115%] mobile_fix rounded-lg ${
                  (isCompleted || isCurrent)
                    ? 'text-white bg-[linear-gradient(160.41deg,#FF8E1C_-5.15%,#FF8E1C_87.35%)] border border-[#FFF4E5] border-[0.5px] shadow-[0px_2px_5px_#FFD7A1]'
                    : 'bg-white text-[#A0A3BD] border border-[#F1F2F9] shadow-[0px_3px_6px_#D9D9D9]'
                }`}>
                  {step.number}
                </div>

                {/* vertical connector */}
                {index < steps.length - 1 && (
                  <div className={`w-0.5 h-14 mt-2 rounded ${
                    (isCompleted || isCurrent)
                      ? ' bg-[#FF8E1C]'
                      : 'bg-[#FFD7A1] '
                  }`} />
                )}
              </div>
              <div className="flex-1 text-left">
                <h3 className="font-lato not-italic font-semibold text-[16px] leading-[150%] text-black mobile_fix">
                  {step.title}
                </h3>
                <p className="font-lato not-italic font-normal text-[12px] leading-[150%] text-[#6F6C8F]">{step.subtitle}</p>
              </div>
            </div>
          );
        })}
      </div>
    </div>
  );

  return (
    <>
      {/* Desktop Sidebar - Shows above 993px */}
      <div className="w-[300px] bg-[#FFF4E5] border border-[#F1F2F9] shadow-[0px_1px_8px_rgba(25,33,61,0.06)] rounded-[24px] md-993:block hidden">
        <SidebarContent />
      </div>

      {/* Mobile Sidebar Overlay */}
      {isMobileMenuOpen && (
        <div 
          className="mobile-sidebar-overlay"
          onClick={closeMobileMenu}
        >
          <div 
            className="mobile-sidebar-container w-[280px] h-full bg-[#FFF4E5] rounded-r-[24px] overflow-hidden border border-[#F1F2F9] shadow-[0px_1px_8px_rgba(25,33,61,0.06)]"
            onClick={(e) => e.stopPropagation()}
          >
            <SidebarContent />
          </div>
        </div>
      )}
    </>
  );
};

export default Sidebar;